import React from "react";
import { connect } from "react-redux";
import { setCartItems, setCartTotals } from "../../../Redux/slices/cart";
import { toggleATCConfirmation } from "../../../Redux/slices/singleProduct";
import { client } from "../../../../App";
import { ADD_TO_CART } from "../../../apollo";
import { RegisterAddToCart } from "../../../Pixel";

const mapStateToProps = state => {
    return {
        activeVariantId: state.singleProduct.activeVariation.id,
        productMainImage: state.singleProduct.mainImage
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCartItems: payload => dispatch(setCartItems(payload)),
        toggleATCConfirmation: payload => dispatch(toggleATCConfirmation(payload)),
        setCartTotals: payload => dispatch(setCartTotals(payload))
    }
}

class AddToCart extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            error: {
                hasError: false,
                errorMessage: ""
            }
        }
        this.addToCart = this.addToCart.bind(this);
    }

    addToCart() {
        if (!this.props.activeVariantId) return false;

        this.setState({ loading: true });

        client.mutate({
            mutation: ADD_TO_CART,
            variables: {
                productID: this.props.productId,
                variationID: this.props.activeVariantId
            }
        }).then(resp => {
            this.setState({ loading: false });
            var cart = resp.data.addToCart.cart;
            
            // Set cart items
            this.props.setCartItems({
                itemCount: cart.contents.itemCount,
                items: cart.contents.nodes.map(item => {
                    return {
                        id: item.product.node.databaseId,
                        cartKey: item.key,
                        quantity: item.quantity,
                        mainImageSrc: item.product.node.image.mediaItemUrl,
                        name: item.product.node.name,
                        price: item.variation.node.price,
                        size: item.variation.node.attributes.nodes[0].value
                    };
                })
            });

            // Add to pixel
            RegisterAddToCart(this.props.productId);

            // Set cart totals
            this.props.setCartTotals({
                total: cart.total,
                subTotal: cart.subtotal,
                tax: cart.totalTax
            });

            // Display ATC Confirmation
            this.props.toggleATCConfirmation({ visible: true });

        }).catch(error => {
            // ! error handling
            this.setState({ loading: false });
            console.error(error);
        });
    }

    render() {
        return <div className="atc-wrap">
            {this.props.children}

            <div className={"atc-btn" + (this.state.loading ? " loading" : "")} onClick={this.addToCart}>
                Add to cart
            </div>
        </div>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCart);